
import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import { AppSwitch, AppInput, AppSwitchForm } from '@/components'
import DetailAppleDeveloperProgramForm from './DetailAppleDeveloperProgramForm.vue'
import DetailAppleAccountForm from './DetailAppleAccountForm.vue'
import DetailDDAppleAccountForm from './DetailDDAppleAccountForm.vue'
import DetailAppleScreenshotsForm from './DetailAppleScreenshotsForm.vue'
import { ChildComponentMixin } from '@/mixins'
import { appEntity } from '@/models/models'
import { READY_FOR_SALE } from '@/utils/statusApp'

@Component({
    components: {
        AppInput,
        AppSwitch,
        AppSwitchForm,
        DetailAppleAccountForm,
        DetailAppleDeveloperProgramForm,
        DetailAppleScreenshotsForm,
        DetailDDAppleAccountForm,
    },
})
export default class DetailApple extends mixins(ChildComponentMixin) {
    @Prop() public value?: AppEntity

    private packageNameCopy = {
        icon: 'copy',
        hint: '',
    }

    get app(): AppEntity {
        return this.value ?? appEntity
    }

    public showAppUrl(): boolean {
        if (this.app.iOS) {
            const index = this.app.iOS.updates.findIndex((u) => u.status === READY_FOR_SALE)
            if (index !== -1) {
                return true
            }
        }
        return false
    }

    public goToAppStore(e: Event) {
        if (this.app.iOS) {
            window.open(this.app.iOS.url, '_blank')
        }
    }

    public copyToClipboard(e: Event) {
        (document.querySelector('#bundleId input') as any).select()
        document.execCommand('copy')

        this.packageNameCopy.hint = 'Copiado'
        this.packageNameCopy.icon = 'check-circle'
    }

    public accountTypeChanged(value: string) {
        setTimeout(() => {
            this.update(this.app, 'brand.settings.webviewVersion', value === 'individual')
        }, 100)
    }
}
